/**
 * Шрифты. Отдельным файлом, потому что это единственная часть системы
 * с внешней зависимостью — всё остальное держится на нуле пакетов.
 *
 * Self-hosted через @fontsource, а не через Google Fonts CDN. Причина не
 * идеологическая: мини-апп живёт в WebView Telegram, где сеть бывает
 * медленной и обрезанной, а падение CDN означает подмену антиквы на Times
 * прямо посреди расклада.
 *
 * Три семейства, у каждого одна работа. Четвёртого не будет: как только
 * у шрифта нет своей работы, он становится украшением.
 *
 *   Prata     — витрина. Имя карты, заголовок экрана. Только ≥28px.
 *   Golos     — интерфейс. Кнопки, лейблы, мета, навигация.
 *   Literata  — чтение. Тело предсказания и вопрос от карты.
 *
 * Почему не Playfair Display, который был здесь раньше: он превратился
 * в кнопку «сделай изящно» и читается именно так. Prata — тоже дидон,
 * но с более плотным ритмом и без этого шлейфа.
 *
 * Подключены только используемые начертания. Каждое лишнее — килобайты
 * до первой отрисовки текста. Берём и кириллицу, и латиницу: в текстах
 * карт встречается и то и другое.
 */

/* ── Golos Text: весь интерфейс ─────────────────────────────────────────
   400 — тело, 500 — лейблы и кнопки, 600 — заголовки и цифры. */
@import '@fontsource/golos-text/cyrillic-400.css';
@import '@fontsource/golos-text/latin-400.css';
@import '@fontsource/golos-text/cyrillic-500.css';
@import '@fontsource/golos-text/latin-500.css';
@import '@fontsource/golos-text/cyrillic-600.css';
@import '@fontsource/golos-text/latin-600.css';

/* ── Prata: только витрина ──────────────────────────────────────────────
   Ровно одно начертание — 400. Другого у Prata нет, и это к лучшему:
   правило «Prata только крупно» становится невозможно нарушить незаметно.
   На мелком кегле её волосяные линии в Android WebView исчезают. */
@import '@fontsource/prata/cyrillic-400.css';
@import '@fontsource/prata/latin-400.css';

/* ── Literata: чтение ───────────────────────────────────────────────────
   Книжная антиква, нарисованная под экран. Через неё проходит 90% ценности
   продукта — текст расклада.
   400 — тело, 500-italic — вопрос от карты, единственный курсив в системе. */
@import '@fontsource/literata/cyrillic-400.css';
@import '@fontsource/literata/latin-400.css';
@import '@fontsource/literata/cyrillic-500-italic.css';
@import '@fontsource/literata/latin-500-italic.css';
